
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/m/[multimedia]",
      function () {
        return require("private-next-pages/m/[multimedia].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/m/[multimedia]"])
      });
    }
  